<template>
<div class="tags has-addons" :class="{ 'is-selected': selected }">
  <span class="tag">{{ label }}</span>
  <a @click.prevent="remove" class="tag is-delete"></a>
</div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    remove () {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

$border-color: #ddd;

.tag:not(body).is-delete {
  margin-left: 0;
}

.tag:not(.is-delete) {
  border: solid 1px $border-color;
  border-right: none;
}

.tag:not(body).is-delete {
  border: solid 1px $border-color;
  border-left: none;
}

.tags.has-addons {
  flex-wrap: nowrap;
}

.tags .tag {
  margin-bottom: 0rem;
}

.tags.is-selected {
  .tag:not(.is-delete) {
    border: solid 1px $brand-primary;
    border-right: none;
  }
  .tag:not(body).is-delete {
    border: solid 1px $brand-primary;
    border-left: none;
  }

  box-shadow: 0px 0px 2px 1px rgba($brand-primary, 0.2);
}

</style>



// WEBPACK FOOTER //
// src/components/general/tag.vue